<template>
  <NavigationDrawer :open="open" @hide="$emit('update:open', false)">
    <div class="navigation-drawer-container">
      <div class="navigation-drawer-title">
        <h4>
          Filters <template v-if="filterCount">({{ filterCount }})</template>
        </h4>
        <div v-if="productsCount">{{ productsCount }} item<template v-if="productsCount > 1">s</template></div>
      </div>
    </div>
    <select-input
      :modelValue="sort"
      @update:modelValue="$emit('update:sort', $event)"
      title="Sort by:"
      :options="SortOptions"
      :disabled="!taxonomyAttributes || !SortOptions.length"
      :expand="true"
    ></select-input>
    <div class="navigation-drawer-container navigation-drawer-buttons">
      <button
        :disabled="!filterCount"
        class="clear-filters-button secondary small uppercase no-margin"
        :class="{ disabled: !filterCount || !filterCount }"
        @click.prevent="$emit('clearFilter')"
      >
        Clear
      </button>
      <button class="done-button small uppercase no-margin" @click.prevent="$emit('update:open', false)">Done</button>
    </div>
    <div class="navigation-drawer-filters">
      <filter-group v-if="showStockFilter" :title="'Availability'" :is-custom="true" :allow-collapse="true">
        <template v-slot:options>
          <Checkbox v-model="filter.inStock" :circle="true" :title="'In Stock'" :disabled="!filter.inStock && (!stockCount || stockCount < 1)" />
        </template>
      </filter-group>
      <filter-group
        v-if="taxonomyCategories.length"
        v-model="filter['taxonomyCategories']"
        :options="taxonomyCategories"
        :title="'Product'"
        :allow-collapse="true"
        :allow-expand="false"
      ></filter-group>
      <template v-for="attribute in taxonomyAttributes" :key="`taxonomy-attribute-${attribute.id}`">
        <filter-group
          v-model="filter['taxonomyAttributes']"
          :options="attribute.attributes"
          :title="attribute.name"
          :allow-collapse="true"
          :allow-expand="false"
        ></filter-group>
      </template>
      <filter-group v-if="showSaleFilter || showClearanceFilter" :title="'Sale'" :is-custom="true" :allow-collapse="true">
        <template v-slot:options>
          <Checkbox
            v-if="showSaleFilter"
            v-model="filter.onSale"
            :circle="true"
            :title="'Current Sale'"
            :disabled="!filter.onSale && (!saleCount || saleCount < 1)"
          />
          <Checkbox
            v-if="showClearanceFilter"
            v-model="filter.onClearance"
            :circle="true"
            :title="'Clearance Sale'"
            :disabled="!filter.onClearance && (!clearanceCount || clearanceCount < 1)"
          />
        </template>
      </filter-group>
    </div>
  </NavigationDrawer>
</template>
<script>
import NavigationDrawer from './NavigationDrawer.vue';
import FilterGroup from '@/components/browseNa/FilterGroup.vue';
import { SortOptions } from '@/components/commons/SortOptions.js';
import {
  Select,
  Checkbox,
} from '@/pixel/index';

export default {
  components: {
    NavigationDrawer,
    FilterGroup,
    Checkbox,
    'select-input': Select,
  },

  props: {
    open: {
      type: Boolean,
      default: false
    },
    filterCount: {
      type: Number,
      default: 0
    },
    filter: {
      type: Object,
      default: () => ({})
    },
    taxonomyCategories: {
      type: Array,
      default: () => ([])
    },
    taxonomyAttributes: {
      type: Array,
      default: () => ([])
    },
    sort: {
      type: String,
    },
    productsCount: {
      type: Number,
      default: 0
    },
    showSaleFilter: {
      type: Boolean,
      default: true
    },
    showClearanceFilter: {
      type: Boolean,
      default: true
    },
    showStockFilter: {
      type: Boolean,
      default: true
    },
    saleCount: {
      type: Number,
      default: 0
    },
    clearanceCount: {
      type: Number,
      default: 0
    },
    stockCount: {
      type: Number,
      default: 0
    }
  },

  emits: ['update:open', 'update:sort', 'clearFilter'],

  setup() {
    return {
      SortOptions
    };
  }
}
</script>
<style lang="postcss" scoped>
@import '@/pixel/style/variables';
  
@media (min-width: $tablet-breakpoint) {
.navigation-drawer {
    display: none;
  }
}

.navigation-drawer-container {
  padding: 20px;
}

.navigation-drawer-filters {
  padding-top: var(--space-1);
  border-top: 1px solid var(--border-color);
}

.navigation-drawer-buttons {
  display: flex;
  padding-left: 10px;
  padding-right: 10px;

  .clear-filters-button {
    margin-right: 10px;
  }

  .clear-filters-button,
  .done-button {
    width: 100%;
  }
}

.navigation-drawer-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.navigation-drawer-toggles {
  & > * {
    margin-bottom: 15px;
  }
}
</style>